var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "broadcast-sended-details" }, [
    _c("div", { staticClass: "broadcast-sended-details-title" }, [
      _vm._v(_vm._s(_vm.$t("wp.sendingStatuses"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "broadcast-sended-details-header" }, [
      _c("div", { staticClass: "broadcast-sended-details-stats" }, [
        _c("div", { staticClass: "stat-box success" }, [
          _c("div", { staticClass: "stat-label" }, [
            _vm._v(_vm._s(_vm.$t("task.success"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.successCount)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stat-box failure" }, [
          _c("div", { staticClass: "stat-label" }, [
            _vm._v(_vm._s(_vm.$t("wp.failed"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.failureCount)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stat-box enqueued" }, [
          _c("div", { staticClass: "stat-label" }, [
            _vm._v(_vm._s(_vm.$t("wp.inProcess"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.enqueuedCount)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "broadcast-sended-details-filters ml-3" },
        [
          _c(
            "a-form-item",
            {
              staticClass: "status-filter",
              attrs: { label: _vm.$t("chatbotv2.state") },
            },
            [
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.statusFilter,
                    callback: function ($$v) {
                      _vm.statusFilter = $$v
                    },
                    expression: "statusFilter",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "all" } }, [
                    _vm._v(_vm._s(_vm.$t("chatWindow.all"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "enqueued" } }, [
                    _vm._v(_vm._s(_vm.$t("wp.sendingStatus"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "sent" } }, [
                    _vm._v(_vm._s(_vm.$t("wp.sent"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "delivered" } }, [
                    _vm._v(_vm._s(_vm.$t("message.delivered"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "read" } }, [
                    _vm._v(_vm._s(_vm.$t("form.read"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "failed" } }, [
                    _vm._v(_vm._s(_vm.$t("wp.failed"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            {
              staticClass: "failure-reason-filter",
              attrs: { label: _vm.$t("wp.errorMessage") },
            },
            [
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.failureReasonFilter,
                    callback: function ($$v) {
                      _vm.failureReasonFilter = $$v
                    },
                    expression: "failureReasonFilter",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "all" } }, [
                    _vm._v(_vm._s(_vm.$t("wp.allErrors"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.distinctFailureReasons, function (reason) {
                    return _c(
                      "a-select-option",
                      {
                        key: reason,
                        staticClass: "failure-reason-item",
                        attrs: { value: reason, title: reason },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(reason) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "broadcast-sended-details-download" },
      [
        _c(
          "SupsisButton",
          { attrs: { ghost: "" }, on: { click: _vm.downloadCSV } },
          [
            _c("a-icon", { attrs: { type: "download" } }),
            _vm._v(
              "\n            " + _vm._s(_vm.$t("wp.downloadCSV")) + "\n        "
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          { attrs: { ghost: "" }, on: { click: _vm.downloadExcel } },
          [
            _c("a-icon", { attrs: { type: "file-excel" } }),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("message.excelDownload")) +
                "\n        "
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "broadcast-sended-details-table" },
      [_c("SupsisTable", { attrs: { columns: _vm.cols, rows: _vm.details } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }